export function shouldShowApprovalEdit(approvalRequest) {
  if (!(approvalRequest != null && approvalRequest.id)) {
    return false;
  }
  const {
    toolName,
    payloadSchema,
    initialPayload
  } = approvalRequest;
  if (!isValidPayloadSchema(payloadSchema)) {
    return false;
  }
  if (!isValidPayload(initialPayload, toolName)) {
    return false;
  }
  return true;
}
const isValidPayloadSchema = payloadSchema => {
  if (!payloadSchema || typeof payloadSchema !== 'object' || !('type' in payloadSchema) || payloadSchema.type !== 'object' || !('properties' in payloadSchema) || !payloadSchema.properties || typeof payloadSchema.properties !== 'object' || Object.keys(payloadSchema.properties).length === 0) {
    return false;
  }
  return true;
};
const isValidPayload = (payload, toolName) => {
  if (!payload || typeof payload !== 'object' || Object.keys(payload).length === 0) {
    return false;
  }

  // Calling Wix Site API tool without any params (nothing to edit)
  if (toolName === 'CallWixSiteAPI' && (!('body' in payload) || typeof payload.body !== 'object' || !payload.body || Object.keys(payload.body).length === 0)) {
    return false;
  }
  return true;
};
//# sourceMappingURL=shouldShowApprovalEdit.js.map